import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import CreateBranch from "./CreateBranch";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import axiosInstance from "../../../helpers/axios";
import EditIcon from "@mui/icons-material/Edit";
import EditBranch from "./EditBranch";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
export default function BranchManagement(props) {
  const { activeTab } = props;
  const decode = useCurrentUser();
  const user = null;
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDrawer, setOpenEditDrawer] = useState(false)
  const [branches, setBranches] = useState([]);
  const [branchDetails, setBranchDetails] = useState({})
  useEffect(() => {
    getClientAllBranches();
  }, []);

  const getClientAllBranches = async () => {
    try {
      const res = await axiosInstance(
        `/client-branches/info/clientId?clientId=${decode.clientId}`,
        {
          headers: {
          },
        }
      );
      setBranches(res?.data?.data?.branches);
    } catch (error) {
      console.error("Failed to fetch branches");
    }
  };

 
  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          mb: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={() => setOpenDrawer(true)}
          sx={{
            border: "1px solid #fc9739ff",
            // color: "#fff",
            textTransform: "none",
          }}
          startIcon={<AddOutlinedIcon />}
        >
          Add Branch
        </Button>
      </Box>

      {/* Table */}
      <Paper>
        <Table>
          <TableHead sx={{ backgroundColor: "#F8F8F8" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Branch Name</TableCell>
               <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>District</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>State</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Pincode</TableCell>
              {(decode?.role === "admin" ||
                decode?.role === "institute_admin") && (
                <TableCell sx={{ fontWeight: "bold" }} align="right">
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {branches.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No branches added
                </TableCell>
              </TableRow>
            ) : (
              branches.map((branch, index) => (
                <TableRow key={index}>
                  <TableCell>{branch.branchName}</TableCell>
                   <TableCell>{branch.address}</TableCell>
                  <TableCell>{branch.city}</TableCell>
                  <TableCell>{branch.district}</TableCell>
                  <TableCell>{branch.state}</TableCell>
                  <TableCell>{branch.pincode}</TableCell>
                  {(decode?.role === "admin" ||
                    decode?.role === "institute_admin") && (
                    <TableCell align="right"
                      sx={{ display: "flex", }}
                    >
                      <EditIcon onClick={() => {
                        setBranchDetails(branch)
                        setOpenEditDrawer(true)
                      }}/>
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>

      {/* Right Drawer */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box sx={{ width: 420 }}>
          <CreateBranch
            onSuccess={() => {
              getClientAllBranches();
              setOpenDrawer(false);
            }}
          />
        </Box>
      </Drawer>
      <Drawer
        anchor="right"
        open={openEditDrawer}
        onClose={() => setOpenEditDrawer(false)}
      >
        <Box sx={{ width: 420 }}>
          <EditBranch 
            branchDetails={branchDetails}
            onSuccess={() => {
              getClientAllBranches();
              setOpenEditDrawer(false);
            }}
          />
        </Box>
      </Drawer>
    </Box>
  );
}
